import { Project } from 'new/entities/Project';
import { Column } from 'new/elements/Table/types';
import { Stack } from 'new/elements/Stack';
import { ChipWithCopy } from 'new/elements/ChipWithCopy';
import { ReactComponent as FolderIcon } from 'new/components/icons/folder.svg';
import DateUtils from 'js/lib/DateUtils';
import { Typography } from '@mui/material';
import styles from 'new/components/pipelines/ProjectsList/ProjectList.module.scss';
import React, { CSSProperties } from 'react';
import TagsView from 'js/components/elements/tags/TagsView';
import { RESOURCE_TYPE_PROJECTS } from 'js/constants/resourceTypes';
import { isEmpty } from 'lodash';

import { styled } from '@mui/system';

const CircleElement = styled('div')(({ theme }) => ({
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.primary.light,
  padding: '2px 5px',
  borderRadius: 8,
}));

type GetColumns = {
  onDetailClicked: (data: Project, tab: string) => void;
  usersByID: { [id: string]: any };
};

const ownerStyle = {
  'word-break': 'break-all',
} as CSSProperties;

export const getColumns = ({ usersByID }: GetColumns): Column<Project>[] => [
  {
    name: 'Project',
    field: 'name',
    renderRow: (row: any) => (
      <Stack direction="row" spacing="12px">
        <FolderIcon />
        <Stack>
          <Typography variant="subtitle2">{row.name}</Typography>
          {row.description && <Typography variant="body3">{row.description}</Typography>}
          <Stack spacing="8px" direction="row" alignItems="center" paddingTop="10px">
            <ChipWithCopy tooltipTitle="Copy Project ID" toCopy={`${row.id}`}>
              ID {row.id}
            </ChipWithCopy>
            <Typography variant="body3">
              <b>CREATED ON:</b> {DateUtils.convertDateStringToFormat(row.created_at)}
            </Typography>
          </Stack>
          {!isEmpty(row?.tags || []) && (
            <Stack marginTop={1.5}>
              <TagsView data={row} resourceType={RESOURCE_TYPE_PROJECTS} />
            </Stack>
          )}
        </Stack>
      </Stack>
    ),
    width: 60,
  },
  {
    name: 'Resources',
    field: 'name',
    renderRow: (row) => (
      <div className={styles.projectsCount}>
        <CircleElement>{row?.flows_count || 0}</CircleElement>
        <Typography variant="caption">Data Flows</Typography>
      </div>
    ),
    width: 22,
  },
  {
    name: 'Owner',
    field: 'owner.full_name',
    renderRow: (row) => (
      <Typography variant="subtitle2" component="span" style={ownerStyle}>
        {usersByID[row.owner]?.full_name || usersByID[row.owner]?.name}
      </Typography>
    ),
  },
];
